import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { WhatsAppGroupsList } from '@/features/whatsapp/components/WhatsAppGroupsList';
import { WhatsAppGroupDetails } from '@/features/whatsapp/components/WhatsAppGroupDetails';
import { WhatsAppWuzapiConnection } from '@/features/whatsapp/components/WhatsAppWuzapiConnection';
import { whatsappService, WhatsAppGroup } from '@/features/whatsapp/services/whatsapp.service';

export const Route = createFileRoute('/_authenticated/whatsapp-config')({
  component: WhatsAppConfigPage,
});

function WhatsAppConfigPage() {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  const { data: groups = [] } = useQuery({
    queryKey: ['whatsapp-groups'],
    queryFn: () => whatsappService.getAllGroups(),
  });

  const selectedGroup = groups.find((g) => g.id === selectedGroupId) || null;

  const handleGroupSelect = (group: WhatsAppGroup) => {
    setSelectedGroupId(group.id);
  };

  const handleBack = () => {
    setSelectedGroupId(null);
  };

  return (
    <PermissionGate permission={Permission.MATTERMOST_CONFIG}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Configuração do WhatsApp</h1>
          <p className="text-muted-foreground mt-2">
            Conecte o número de WhatsApp da empresa e gerencie a integração dos grupos com os
            boards do Notion
          </p>
        </div>

        <Tabs defaultValue="connection" className="w-full">
          <TabsList>
            <TabsTrigger value="connection">Conexão</TabsTrigger>
            <TabsTrigger value="groups">Grupos</TabsTrigger>
          </TabsList>

          <TabsContent value="connection">
            <WhatsAppWuzapiConnection />
          </TabsContent>

          <TabsContent value="groups">
            {selectedGroup ? (
              <WhatsAppGroupDetails group={selectedGroup} onBack={handleBack} />
            ) : (
              <WhatsAppGroupsList onGroupSelect={handleGroupSelect} />
            )}
          </TabsContent>
        </Tabs>
      </div>
    </PermissionGate>
  );
}
